import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { TokenService } from 'src/app/shared/services/token.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { GetterSetterService } from '../../../shared/services/getter-setter.service';

@Component({
  selector: 'app-sovos-callback',
  templateUrl: './sovos-callback.component.html'
})
export class SovosCallbackComponent implements OnInit {
  displayConsentModal: boolean = false;
  isChecked: boolean = false;
  isSubmittedConsent: boolean = false;
  consentLoginData: any = {};
  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private tokenService: TokenService,
    private toaster: ToasterService,
    private getSet: GetterSetterService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      const state = params['state'];
      if (!code || !state) {
        this.toaster.showError('Invalid callback parameters.');
        this.router.navigate(['login']);
        return;
      }
   

      this.authService.processSovosCallbackGet(code, state).subscribe({
        next: (resp: any) => {

          if (resp) {
            try {
              // Adapted from proceedForLogin: handle success, MFA and session initialization
              if (resp.status === 'SUCCESS') {
                if (resp.response?.mfa_enable) {
                  this.getSet.getSetUserId(resp.response.email);
                  this.authService.setLoginIndicator(0);
                  this.getSet.setMFACode(resp.response.mfa_enable);
                  this.router.navigate(['verify-otp']);
                } else {
                  this.toaster.showSuccess('Login Successful.');
                  this.tokenService.setter(resp.response);
                  this.authService.setLoginIndicator(2);
                  this.getSet.getSetUser(resp.response.username);
                  this.getSet.getSetSapphireTenent(resp.response.sapphireTenant);
                  this.getSet.getSetUserId(resp.response.email);
                  if (resp.response.rootCompanyid != undefined) {
                    this.getSet.getSetCompanyId(resp.response.rootCompanyid);
                    this.getSet.getSetCompany(resp.response.rootCompanyName);
                    if (resp.response.products && resp.response.products.length > 0) {
                      this.getSet.setProduct(resp.response.products);
                    }
                    this.router.navigate(['dashboard']);
                  } else {
                    this.router.navigate(['add-business']);
                  }
                }
              } else {
                // Error cases adapted from proceedForLogin
                if (resp.response != null && resp.response.isValidPassword == false) {
                  this.toaster.showError(
                    'Your password has expired and must be changed after redirecting.'
                  );
                  this.authService.setLoginEmail(resp.response.email);
                  this.router.navigate(['change-password']);
                }
                if (resp.response == null && resp.message == 'Consent is not provided.') {
                  this.showConsentModal?.();
                }
                this.toaster.showError(resp.message);
              }
            } catch (e) {
              this.toaster.showError('Login succeeded but failed to initialize session.');
              this.router.navigate(['login']);
            }
          } else {
            this.toaster.showError(resp?.message || 'Sovos authentication failed.');
            this.router.navigate(['login']);
          }
        },
        error: (error) => {
          console.error('Sovos callback GET processing error:', error);
          this.toaster.showError(
            error && error.message
              ? `There was an error processing the Sovos callback: ${error.message}`
              : 'There was an error processing the Sovos callback.'
          );
        }
      });
    });
  }

  showConsentModal() {
    this.displayConsentModal = true;
    this.isChecked = false;
    this.isSubmittedConsent = false;
  }
}
